"use client";

import { useCallback } from "react";
import z from "zod";
import { emitAppEvent } from "../../events";
import { ConsentAcceptedEvent } from "../../events/consent-accepted.event";
import { ConsentNotShowedEvent } from "../../events/consent-not-showed.event";
import { ConsentRejectedEvent } from "../../events/consent-rejected.event";
import { getCmpData } from "./utils";

const cmpEvents = z.enum(["consentcustom", "consentapproved", "consentrejected", "loadNotShowing"]);

export function useCmpEventListener() {
  const handleCmpEvent = useCallback((event: unknown) => {
    switch (event) {
      case cmpEvents.enum.loadNotShowing: {
        const cmpData = getCmpData();
        if (!cmpData) return;

        emitAppEvent(ConsentNotShowedEvent, cmpData);
        break;
      }
      case cmpEvents.enum.consentcustom:
      case cmpEvents.enum.consentapproved: {
        const cmpData = getCmpData();
        if (!cmpData) return;

        emitAppEvent(ConsentAcceptedEvent, cmpData);
        break;
      }
      case cmpEvents.enum.consentrejected: {
        const cmpData = getCmpData();
        if (!cmpData) return;

        emitAppEvent(ConsentRejectedEvent, cmpData);
        break;
      }
    }
  }, []);

  const initializeCmpListeners = useCallback(() => {
    if (!window.__cmp) return;

    cmpEvents.options.forEach((event) => {
      window.__cmp?.(
        "addEventListener",
        [
          event,
          () => {
            handleCmpEvent(event);
          },
          false,
        ],
        null,
      );
    });
  }, [handleCmpEvent]);

  return { initializeCmpListeners };
}
